import IndicationModal from 'components/project/IndicationModal';
import {
  makeOptionApplyValue,
  makeOptionInitialValue,
  overlappingArrayElements,
} from 'lib/library';
import { indicationOptionList, userCustomOption } from 'lib/mapper';
import { IToothShade, Tooth } from 'lib/types/projectTypes';
import React, { ChangeEvent, useEffect, useState } from 'react';
import { color } from 'styles/utils';

interface IIndicationModalContainerProps {
  isOpenOption: {
    value: boolean;
    onChange: (e: any) => void;
    setValue: (value: boolean | any) => void;
  };
  defaultOption: {
    inputs: {};
    onChange: (event: any) => void;
    setInputs: React.Dispatch<React.SetStateAction<{}>>;
    onReset: () => void;
  };
  advancedOption: {
    inputs: {};
    onChange: (event: any) => void;
    setInputs: React.Dispatch<React.SetStateAction<{}>>;
    onReset: () => void;
  };
  defaultValue: {
    inputs: {};
    onChange: (event: any) => void;
    setInputs: React.Dispatch<React.SetStateAction<{}>>;
    onReset: () => void;
  };
  advancedValue: {
    inputs: {};
    onChange: (event: any) => void;
    setInputs: React.Dispatch<React.SetStateAction<{}>>;
    onReset: () => void;
  };
  indicationAlias: string;
  materialAlias: string;
  teeth: {
    value: object[] | any;
    onChange: (e: any) => void;
    setValue: (value: object[] | any) => void;
  };
  tooth: {
    value: Tooth;
    onChange: (e: any) => void;
    setValue: (value: Tooth) => void;
  };
  numbering: { value: number; onChange: (e: any) => void; setValue: (value: number) => void };
  restorationPontic: {
    value: number;
    onChange: (e: any) => void;
    setValue: (value: number) => void;
  };
  occlusalSurface: {
    value: number;
    onChange: (e: any) => void;
    setValue: (value: number) => void;
  };
  ceramicMetal: {
    value: number;
    onChange: (e: any) => void;
    setValue: (value: number) => void;
  };
  materialShadeList: IToothShade[];
  indicationFormat: any;
  indicationInfo: any;
  indicationOption: any;
  indicationSeqList: any;
  matchingIndicationPartList: any;
  matchingMaterialList: any;
  matchingImplantList: any;
  matchingAbutmentList: any;
  matchingScanbodyList: any;
  material: { value: string; onChange: (e: any) => void; setValue: (value: string) => void };
  implant: { value: number; onChange: (e: any) => void; setValue: (value: number) => void };
  abutment: {
    value: number | null;
    onChange: (e: any) => void;
    setValue: (value: number | null) => void;
  };
  scanbody: {
    value: number | null;
    onChange: (e: any) => void;
    setValue: (value: number | null) => void;
  };
  checkSituScan: {
    value: boolean | number;
    onChange: (e: any) => void;
    setValue: (value: boolean | number) => void;
  };
  checkGingivaScan: {
    value: boolean | number;
    onChange: (e: any) => void;
    setValue: (value: boolean | number) => void;
  };
  gapWidthCement: {
    value: number | number[] | string | any; // input value 입력시 string
    onChange: (e: any) => void;
    setValue: (value: number | number[] | string | any) => void;
  };
  minimalTickness: {
    value: number | number[] | string | any; // input value 입력시 string
    onChange: (e: any) => void;
    setValue: (value: number | number[] | string | any) => void;
  };
  millingToolDiameter: {
    value: number | number[] | string | any; // input value 입력시 string
    onChange: (e: any) => void;
    setValue: (value: number | number[] | string | any) => void;
  };
  virtualGingiva: {
    value: number;
    onChange: (e: any) => void;
    setValue: (value: number) => void;
  };
  thimbleCrown: {
    value: number;
    onChange: (e: any) => void;
    setValue: (value: number) => void;
  };
  waxupScan: {
    value?: number | null;
    onChange: (e: any) => void;
    setValue: (value?: number | null) => void;
  };
  cervicalAdaption: {
    value: number;
    onChange: (e: any) => void;
    setValue: (value: number) => void;
  };
  materialShade: { value: number; onChange: (e: any) => void; setValue: (value: number) => void };
  indicationSeq: {
    value: number;
    onChange: (e: any) => void;
    setValue: (value: number) => void;
  };
  indication: {
    value: {
      // id: number;
      id: string;
      seq: string;
      color: string;
    };
    onChange: (e: any) => void;
    setValue: (value: object) => void;
  };
  isMultidie: {
    value: number;
    onChange: (e: any) => void;
    setValue: (value: number) => void;
  };
  onChooseIndicationPart: (data: {}) => void;
  onChooseMaterial: (seq: string, alias: string) => void;
  onChooseImplant: (seq: number) => void;
  onChooseAbutment: (seq: number) => void;
  onChooseScanbody: (seq: number) => void;
}

function IndicationModalContainer({
  isOpenOption,
  defaultOption,
  advancedOption,
  defaultValue,
  advancedValue,
  indicationAlias,
  materialAlias,
  teeth,
  tooth,
  numbering,
  materialShadeList,
  indicationFormat,
  indicationInfo,
  indicationOption,
  indicationSeqList,
  matchingIndicationPartList,
  matchingMaterialList,
  matchingImplantList,
  matchingAbutmentList,
  matchingScanbodyList,
  material,
  implant,
  abutment,
  scanbody,
  checkSituScan,
  checkGingivaScan,
  gapWidthCement,
  minimalTickness,
  millingToolDiameter,
  virtualGingiva,
  thimbleCrown,
  waxupScan,
  cervicalAdaption,
  materialShade,
  restorationPontic,
  occlusalSurface,
  ceramicMetal,
  indicationSeq,
  indication,
  isMultidie,
  onChooseIndicationPart,
  onChooseMaterial,
  onChooseImplant,
  onChooseAbutment,
  onChooseScanbody,
}: IIndicationModalContainerProps) {
  const [matchMaterailListDef, setMatchMaterailListDef] = useState<any[]>([]);
  const [matchMaterailListCM, setMatchMaterailListCM] = useState<any[]>([]);
  const [optionTab, setOptionTab] = useState(0);
  const [isBeElement, setIsBeElement] = useState({
    checkBox: false,
    radioButton: false,
    slider: false,
  });
  useEffect(() => {
    if (matchingMaterialList.length <= 0) return;
    setMatchMaterailListDef([]);
    setMatchMaterailListCM([]);
    // NOTE:material 구분 default, custom
    matchingMaterialList.map((item: any) => {
      if (item.alias.split('_')[0] == userCustomOption.material) {
        setMatchMaterailListCM(draft => [...draft, item]);
      } else {
        setMatchMaterailListDef(draft => [...draft, item]);
      }
    });
  }, [matchingMaterialList]);

  useEffect(() => {
    let isCheckBox = false;
    let isRadioButton = false;
    let isSlider = false;

    if (!!defaultOption?.inputs) {
      indicationOptionList.default.checkBox.map((option: any) => {
        if (option.key in defaultOption?.inputs) {
          isCheckBox = true;
        }
      });
      indicationOptionList.default.radioButton.map((option: any) => {
        if (option.key in defaultOption?.inputs) {
          isRadioButton = true;
        }
      });
      indicationOptionList.default.slider.map((option: any) => {
        if (option.key in defaultOption?.inputs) {
          isSlider = true;
        }
      });
    }
    setIsBeElement({ checkBox: isCheckBox, radioButton: isRadioButton, slider: isSlider });
  }, [defaultOption]);

  const handleCloseModal = () => {
    isOpenOption.setValue(false);
  };

  const handleClickTab = (event: ChangeEvent<{}>, newValue: number) => {
    setOptionTab(newValue);
  };

  const handleApply = () => {
    if (!tooth.value.number) return;

    const defaultData = makeOptionApplyValue(defaultValue.inputs, defaultOption.inputs);
    const advancedData = makeOptionApplyValue(advancedValue.inputs, advancedOption.inputs);

    let applyToothData = {
      number: tooth.value.number,
      preparationType: indicationSeq.value, // indication Seq
      indicationIdx: indication.value.seq, // indication Id, materialList 대분류, 기존 id -> seq로 변경
      reconstructionType: indication.value.seq, // 색상 요소, materialList 소분류
      color: indication.value.color || color.blue,
      material: material.value,
      implantType: implant.value,
      implantAbutmentMaterialIdx: abutment.value,
      implantScanbodyScanIdx: scanbody.value,
      // situScan: !!checkSituScan.value ? 1 : 0,
      // separateGingivaScan: !!checkGingivaScan.value ? 1 : 0,
      // gapWidthCement: parseFloat(gapWidthCement.value),
      // minimalTickness: parseFloat(minimalTickness.value),
      // millingToolDiameter: parseFloat(millingToolDiameter.value),
      // virtualGingiva: virtualGingiva.value,
      // thimbleCrown: thimbleCrown.value,
      // waxupScan: indicationSeq.value === 4 ? waxupScan.value : null,
      // cervicalAdaption: cervicalAdaption.value,
      materialShade: materialShade.value,
      default: defaultData,
      advanced: advancedData,
      indicationAlias: indicationAlias,
      materialAlias: materialAlias,
      isLast: true,
      description: tooth.value.description,
    };

    // console.log('applyToothData ______ ', applyToothData);
    // apply 시점 발생 이벤트
    // copyData, tooth.hasData = true, TeethContextMenu paste active, set teeth
    teeth.setValue((draft: any) =>
      overlappingArrayElements({ list: draft, value: applyToothData, condition: 'number' }),
    );
    tooth.setValue({ ...applyToothData, hasData: true });
    // copyData.setValue({ ...applyToothData, hasData: true });
    // initial
    // gapWidthCement.setValue(0.08);
    // minimalTickness.setValue(0.6);
    // millingToolDiameter.setValue(1.2);
    isOpenOption.setValue(false);
  };

  const handleReset = () => {
    indicationSeq.setValue(0);
    indication.setValue({});
    material.setValue('0');
    implant.setValue(0);
    abutment.setValue(null);
    scanbody.setValue(null);
    defaultValue.setInputs(makeOptionInitialValue(indicationOption?.default));
    advancedValue.setInputs(makeOptionInitialValue(indicationOption?.advanced));
    materialShade.setValue(0);
  };

  return (
    <IndicationModal
      defaultOption={defaultOption}
      advancedOption={advancedOption}
      defaultValue={defaultValue}
      advancedValue={advancedValue}
      isBeElement={isBeElement}
      teeth={teeth}
      tooth={tooth}
      numbering={numbering}
      materialShadeList={materialShadeList}
      indicationFormat={indicationFormat}
      indicationInfo={indicationInfo}
      indicationOption={indicationOption}
      indicationSeqList={indicationSeqList}
      matchingIndicationPartList={matchingIndicationPartList}
      matchingMaterialList={matchingMaterialList}
      matchingImplantList={matchingImplantList}
      matchingAbutmentList={matchingAbutmentList}
      matchingScanbodyList={matchingScanbodyList}
      matchMaterailListDef={matchMaterailListDef}
      matchMaterailListCM={matchMaterailListCM}
      indicationSeq={indicationSeq}
      indication={indication}
      material={material}
      implant={implant}
      abutment={abutment}
      scanbody={scanbody}
      checkSituScan={checkSituScan}
      checkGingivaScan={checkGingivaScan}
      gapWidthCement={gapWidthCement}
      minimalTickness={minimalTickness}
      millingToolDiameter={millingToolDiameter}
      virtualGingiva={virtualGingiva}
      thimbleCrown={thimbleCrown}
      waxupScan={waxupScan}
      cervicalAdaption={cervicalAdaption}
      materialShade={materialShade}
      restorationPontic={restorationPontic}
      occlusalSurface={occlusalSurface}
      ceramicMetal={ceramicMetal}
      optionTab={optionTab}
      isMultidie={isMultidie}
      onClickTab={handleClickTab}
      onCloseModal={handleCloseModal}
      onChooseIndicationPart={onChooseIndicationPart}
      onChooseMaterial={onChooseMaterial}
      onChooseImplant={onChooseImplant}
      onChooseAbutment={onChooseAbutment}
      onChooseScanbody={onChooseScanbody}
      onApply={handleApply}
      onReset={handleReset}
      // onClearAll={handleClearAll}
    />
  );
}

export default IndicationModalContainer;
